import { createContext, useContext } from 'react'
import type { NamedScanResult } from './scanResultAttachment'
import type { ScanResult } from './types'

/**
 * Scan actions that reach outside the scan hook (into the chat composer /
 * shell). Provided by ChecklistScanPane and consumed deep in the tree
 * (ResultRow, SessionCard) via context, so they don't have to be prop-drilled.
 */
export interface ScanActions {
  /** Attach a single result to the chat composer and switch to the chat view. */
  sendToChat: (result: ScanResult, name: string) => void
  /** Attach a whole run's results as one context and switch to the chat view. */
  sendRunToChat: (items: NamedScanResult[]) => void
}

const ScanActionsContext = createContext<ScanActions | null>(null)

export const ScanActionsProvider = ScanActionsContext.Provider

export function useScanActions(): ScanActions {
  const ctx = useContext(ScanActionsContext)
  if (!ctx) throw new Error('useScanActions must be used within a ScanActionsProvider')
  return ctx
}
